import React from "react";
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { ProfileRoutineMoreActionProps } from "models/propTypes/profileRoutinePropTypes";
import { AuthEnums } from "models/enums";
//#endregion
//#region components
import { MoreActions } from "components/common";
import useProfileRoutineSnoozeAction from "./actions/useProfileRoutineSnoozeAction";
//#endregion
import { CompanyService } from "services";

const ProfileRoutineMoreActions: React.FC<ProfileRoutineMoreActionProps> = (props) => {
  const { profileRoutine, markAsDoneHandler, disableSuccessMessages } = props;

  const snoozeAction = useProfileRoutineSnoozeAction(profileRoutine.id, markAsDoneHandler);

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    const isAuditor = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor);

    if (!isAuditor) {
      actions.push(snoozeAction);
    }

    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={disableSuccessMessages} />;
};

export default ProfileRoutineMoreActions;
